import { useRef } from "react"
import { Sizes } from "../../../interfaces/sizing"
import { useAppSelector } from "../../../store/hooks"
import { selectRoomSubject } from "../../../store/roomSlice"
import { colorClass } from "../../../utils/css"
import { shrinkWrap } from "../../../utils/domUtils"
import { Typography } from "../../common"
import "./BroadcastRoomSubject.scss"

export function BroadcastRoomSubject() {
    const roomSubject = useAppSelector(selectRoomSubject)
    const clearTimeoutsRef = useRef<(() => void) | undefined>(undefined)

    clearTimeoutsRef.current?.()

    if (roomSubject === "") {
        return (
            <div
                className="EmptySubjectSpacer"
                data-testid="broadcast-room-subject-spacer"
            />
        )
    }

    return (
        <div
            className="BroadcastRoomSubject"
            data-testid="broadcast-room-subject"
        >
            <Typography size={Sizes.smpx} color={colorClass.whiteFontColor}>
                <div
                    className="BroadcastRoomSubject__text"
                    ref={(el) => {
                        // When text line-wraps due to a max width, there's no way to achieve {width: fit-content} in css,
                        // and JS like this is required to achieve that
                        if (el !== null) {
                            shrinkWrap(el)

                            // CBD-2809 - On some devices (doesn't seem to be platform correlated) orientation change timing is such that we
                            // need to spam shrinkWrap for a moment so subject doesn't get stuck sized as if the screen were portrait width
                            const interval = window.setInterval(
                                () => shrinkWrap(el),
                                30,
                            )
                            const timeout = window.setTimeout(() => {
                                window.clearInterval(interval)
                                clearTimeoutsRef.current = undefined
                            }, 300)
                            clearTimeoutsRef.current = () => {
                                window.clearInterval(interval)
                                window.clearTimeout(timeout)
                                clearTimeoutsRef.current = undefined
                            }
                        }
                    }}
                >
                    {roomSubject}
                </div>
            </Typography>
        </div>
    )
}
